import { useContext } from 'react';
import file from '../../images/file.svg';
import pdf from '../../images/pdf.svg';
import { ConfigContext } from '../context/ConfigContext';
import type { Attachment } from '../types/ChatWindow';

type AttachmentsProps = {
  show: boolean;
  attachments: Array<Attachment>;
  handleAttachmentCancelClick: (...args: any[]) => void;
};

const getImageForAttachment = (attachment: Attachment) => {
  if (attachment.base64.startsWith('data:image/')) {
    return attachment.base64;
  }

  if (attachment.type === 'application/pdf') {
    return pdf;
  }

  return file;
};

export default function Attachments(props: AttachmentsProps) {
  const { show, attachments, handleAttachmentCancelClick } = props;
  const {
    scheme: {
      header: { messageBarColor },
    },
  } = useContext(ConfigContext);

  return (
    <>
      {show && (
        <div
          className='attachments-container'
          style={{ backgroundColor: messageBarColor }}>
          {attachments.map((attachment, index) => {
            const image = getImageForAttachment(attachment);

            return (
              <>
                <div
                  className='attachment-container-item'
                  key={attachment.name}>
                  <div
                    className='attachment-remove-container'
                    onClick={(e) => handleAttachmentCancelClick(index)}>
                    <i className='fal fa-times-circle attachment-remove-icon' />
                  </div>
                  <img
                    className='attachment-image'
                    alt='attachment'
                    src={`${image}`}
                  />
                  <div className='attachment-name' title={attachment.name}>
                    {attachment.name}
                  </div>
                </div>
              </>
            );
          })}
        </div>
      )}
    </>
  );
}
